import { render } from "./DeleteInterestNote.vue?vue&type=template&id=c67549c4"
import script from "./DeleteInterestNote.vue?vue&type=script&lang=js"
export * from "./DeleteInterestNote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__